import { AssetTransaction } from "./asset_transaction";

export class GenericTransaction extends AssetTransaction {
	// This class is used for generic instantiations of transaction as used e.g. in the history component or the best fee collection

	public hasAction(cancel: boolean = false): boolean {
		return false;
	}

	public isCancelable(): boolean {
		return false;
	}
}
